export const breakpoints = ['480px', '768px', '1024px'];

export const fontSizes = [10, 12, 14, 16, 18, 20, 24, 28, 32, 40, 48, 64, 72];

export const lineHeights = ['18px', '22px', '26px', '34px', '40px', '50px'];

export const space = [0, 4, 8, 16, 24, 32, 64, 72, 128, 256, 512];
